module.exports = __webpack_public_path__ + "img/WhiteFbReview.ae11d445.png";